import axios from 'axios'
import { Notification,Message } from 'element-ui'
import {i18n} from "@/i18n";

let reqUrl = process.env.DYNAMIC_BASE_URL;
export const fileClient = function () {
  const uploadClient = axios.create({
    baseURL: reqUrl,
    timeout: 2*60*1000,
    withCredentials: true,
    responseType: 'blob'
  })

  uploadClient.interceptors.response.use((response) => {
    return response;
    },
  reject => {
    Message.error(i18n.t('m.network_busy'))
    return Promise.reject(reject);
  })

  return uploadClient
}



// WEBPACK FOOTER //
// ./src/api/axios-client-file.js